import { Select, SelectProps } from '@mantine/core';
import React from 'react';

export const CustomSelect = React.forwardRef<HTMLInputElement, SelectProps>(({ styles, ...props }, ref) => {
  return (
    <Select
      ref={ref}
      withScrollArea={false}
      styles={{ dropdown: { maxHeight: 200, overflowY: 'auto' }, ...styles }}
      {...props}
    />
  );
});

CustomSelect.displayName = 'CustomSelect';
